import React from "react";
import { SparkleIcon } from "./icons";

export default function InsightBanner() {
  return (
    <section className="dash-improve an-insight-banner">
      <div className="dash-improve-lead">
        <span className="dash-improve-icon">
          <SparkleIcon />
        </span>
        <div>
          <strong>Insight</strong>
          <span>
            Visitors are most interested in Pricing &amp; Plans. Consider adding more comparison content or FAQs to
            close more leads.
          </span>
        </div>
      </div>

      <button type="button" className="onboarding__btn onboarding__btn--primary an-insight-btn">
        <SparkleIcon />
        View recommendations
      </button>
    </section>
  );
}
